import React from 'react';
import useENotification from '../../../../../hooks/eNotification';

const path = '../oldPages/e-notification/archive-template/index.html';

function ENotificationArchiveTemplate() {
  const { iframeRef } = useENotification();

  return <iframe ref={iframeRef} title="e-notification-archive-template" src={path} width="100%" height="500px" />;
}

export default ENotificationArchiveTemplate;
